import React from 'react';
import { CSSZSickLeaveCertificate } from '../../Interfaces/CSSZ.interface';
import { SickLeaveListRow } from '../../Helpers/buildSickLeaveYearRows.helper';
import CSSZSickLeaveCertificateListItem from './CSSZSickLeaveCertificateListItem';
import CSSZSickLeaveCertificateYearHeader from './CSSZSickLeaveCertificateYearHeader';

interface Props {
	row: SickLeaveListRow;
	activeItemId: string | null;
	onToggleYear: (year: number) => void;
	onSelectCertificate: (item: CSSZSickLeaveCertificate) => void;
}

const CSSZSickLeaveCertificateListRow: React.FC<Props> = ({
	row,
	activeItemId,
	onToggleYear,
	onSelectCertificate,
}) => {
	if (row.rowType === 'yearHeader') {
		return (
			<CSSZSickLeaveCertificateYearHeader
				year={row.year}
				count={row.count}
				isOpen={row.isOpen}
				onToggle={onToggleYear}
			/>
		);
	}

	return (
		<CSSZSickLeaveCertificateListItem
			item={row.sickLeave}
			onClick={onSelectCertificate}
			isActive={activeItemId === row.sickLeave.id}
		/>
	);
};

export default CSSZSickLeaveCertificateListRow;
